import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import { COLOR } from '@src/styles/color';

export const StyledCreditManagement = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 12px;

  .header-card {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .header-card-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
  }

  .filters {
    display: flex;
    gap: 16px;
    align-items: center;
    margin-bottom: 16px;
  }

  .search-input {
    min-width: 30%;
  }

  .body-card {
    margin-bottom: 64px;
  }

  .credit-package-id {
    font-size: 14px;
    color: ${COLOR.blueGray[80]};
  }

  .credit-package-name {
    font-weight: 600;
    color: ${COLOR.text.primary};
  }

  .tool-name {
    color: ${COLOR.text.secondary};
    font-size: 14px;
  }

  .credit-value {
    font-weight: 600;
    color: ${COLOR.primary.dark};
  }

  .loading-cell {
    text-align: center;
    padding: 20px;
    color: ${COLOR.text.secondary};
  }

  .no-data-cell {
    text-align: center;
    padding: 40px 20px;
    color: ${COLOR.text.secondary};
    font-style: italic;
  }
`;
